import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    
    // Initial check
    setMatches(media.matches);

    // Update matches when viewport changes
    function updateMatches() {
      setMatches(media.matches);
    }
    
    // Modern browsers
    media.addEventListener('change', updateMatches);
    
    return () => {
      media.removeEventListener('change', updateMatches);
    };
  }, [query]);

  return matches;
}